import {ContentCardBaseComponent} from 'custom-extensions/ui-components/x-content-card-base';
import {html} from 'lit';
import {defineCustomElement} from 'custom-extensions/ui-utils';
import stylesheet from './x-guide-card.scss?as=stylesheet';
import img from './guide.svg';
import {classMap} from 'lit/directives/class-map.js';

export class GuideCardComponent extends ContentCardBaseComponent {
	static get styles () {
		return [
			...super.styles,
			stylesheet
		];
	}

	static get properties () {
		return {};
	}

	constructor () {
		super();
	}

	renderImage () {
		if (!this.imageUrl) {
			return html`
				<div class="image">
					<x-image src="${img}" alt="${this.name} image"></x-image>
				</div>
			`;
		}

		const imageTypeClass = `image--${this.type}`;
		const classes = {
			image: true,
			[imageTypeClass]: true
		};

		return html`
			<div class="${classMap(classes)}">
				<x-image src="${this.imageUrl}" alt="${this.name} image"></x-image>
			</div>
		`;
	}

	renderInfoLeft () {
		return html`<span class="card-cta">View Guide</span>`;
	}

};

defineCustomElement('x-guide-card', GuideCardComponent);
